import { useQuery } from "react-query";
import { apiEmpleo } from "../../util/ApiEmpleo";

export default function useEmployerFindQuery(searchText: string) {
  return useQuery(
    ["employer/find", searchText],
    async () => {
      const params = {
        page: 1,
        itemsPerPage: 5,
        searchFor: searchText
      };

      let res = await apiEmpleo.get(`employers`, {params});

      return {
        employers: res["hydra:member"],
        totalItems: res["hydra:totalItems"],
        page: params.page
      }
    },
    {
      enabled: searchText !== "",
    }
  )
}